<ol class="breadcrumb fs-5">
  <li class="breadcrumb-item">
    @if (!isIris) {
      <a [routerLink]="'/'" class="breadcrumb-title"><i class="bi bi-chevron-left"></i> Portail Chantier</a>
    }
    @if (isIris) {
      <a [routerLink]="'/'" class="breadcrumb-title"><i class="bi bi-chevron-left"></i> Portail IRIS</a>
    }
  </li>
  @for (path of paths; track path) {
    @if (!path.lien) {
      <li aria-current="page" class="breadcrumb-item active">{{ path.label }}</li>
    }
    @if (path.lien) {
      <li aria-current="page" class="breadcrumb-item active">
        <a [routerLink]="path.lien">{{ path.label }}</a>
      </li>
    }
  }
</ol>
